import _store from "../../../index";

const home = {
  parent_uuid: null,
  icon: "el-icon-s-home",
  type: "element",
  title: "Dashboard",
  link:
    process.env.VUE_APP_STATIC_HOST.replace(/\/+$/i, "").replace(/:\d+$/, "") +
    window.location.port.replace(/^(\d+)$/, ":$1") +
    "/" +
    process.env.VUE_APP_STATIC_PATH.replace(/^\/+/, "").replace(/\/*$/, "/"),
  visible: true,
  disabled: false,
  sort: 0,
  roles: [],
  uuid: "000000000-0000-0000-0000-0000000000000"
};
const defaultState = () => ({
  data: undefined,
  received: undefined,
  collapsed: false
});

const state = defaultState();

// getters
const getters = {
  menuItems: state => {
    if (state.received === undefined) {
      _store.dispatch("cache/shared_menu/getItemsFromBackend");
      return undefined;
    }
    return state.data;
  },
  isCollapsed: state => {
    return state.collapsed;
  }
};

// actions
const actions = {
  loadData(store) {
    return store.rootState.api.query({
      query: require("../../../../graphql/opupet_query.graphql"),
      variables: {
        class: "\\App\\JStorage\\SPA\\JSSharedMenu",
        method: "all",
        params: {}
      }
    });
  },
  saveData(store, data) {
    console.log(data);
    return store.rootState.api
      .query({
        query: require("../../../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedMenu",
          method: "saveAllMenuData",
          params: [data]
        }
      })
      .then(res => {
        store.commit("setData", [home, ...res.data.opupet_query]);
      })
      .catch(res => {
        console.log(res);
        return res;
      });
  },
  getItemsFromBackend(store) {
    if (state.received !== undefined) {
      return;
    }
    store.commit("setReceived", false);
    store
      .dispatch("loadData")
      .catch(() => {
        store.commit("setReceived", true);
        return { data: { opupet_query: [] } };
      })
      .then(res => {
        store.commit("setData", [home, ...res.data.opupet_query]);
        store.commit("setReceived", true);
      });
  },
  toggleMenu(store) {
    store.commit("toggleMenu");
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = data;
  },
  setReceived(state, value) {
    state.received = value;
  },
  toggleMenu(state) {
    state.collapsed = !state.collapsed;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
